module.exports = __webpack_public_path__ + "media/conversa/logoConversa-d57e6af7.png";